/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cta_Metric_UsersInputs */

const en_cta_metric_users = /** @type {(inputs: Cta_Metric_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Users reached`)
};

const ar_cta_metric_users = /** @type {(inputs: Cta_Metric_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مستخدِم وصلوا إليه`)
};

const bn_cta_metric_users = /** @type {(inputs: Cta_Metric_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ব্যবহারকারী`)
};

const de_cta_metric_users = /** @type {(inputs: Cta_Metric_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer erreicht`)
};

const es_cta_metric_users = /** @type {(inputs: Cta_Metric_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usuarios alcanzados`)
};

const fr_cta_metric_users = /** @type {(inputs: Cta_Metric_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilisateurs atteints`)
};

const pt_cta_metric_users = /** @type {(inputs: Cta_Metric_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usuários alcançados`)
};

const zh_cta_metric_users = /** @type {(inputs: Cta_Metric_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用户达到`)
};

const tr_cta_metric_users = /** @type {(inputs: Cta_Metric_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kullanıcı sayısına ulaşıldı`)
};

const ru_cta_metric_users = /** @type {(inputs: Cta_Metric_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Охвачено пользователей`)
};

const pl_cta_metric_users = /** @type {(inputs: Cta_Metric_UsersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dotarto do użytkowników`)
};

/**
* | output |
* | --- |
* | "Users reached" |
*
* @param {Cta_Metric_UsersInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const cta_metric_users = /** @type {((inputs?: Cta_Metric_UsersInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cta_Metric_UsersInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_cta_metric_users(inputs)
	if (locale === "bn") return bn_cta_metric_users(inputs)
	if (locale === "de") return de_cta_metric_users(inputs)
	if (locale === "es") return es_cta_metric_users(inputs)
	if (locale === "fr") return fr_cta_metric_users(inputs)
	if (locale === "pt") return pt_cta_metric_users(inputs)
	if (locale === "zh") return zh_cta_metric_users(inputs)
	if (locale === "tr") return tr_cta_metric_users(inputs)
	if (locale === "ru") return ru_cta_metric_users(inputs)
	if (locale === "pl") return pl_cta_metric_users(inputs)
	return en_cta_metric_users(inputs)
});